"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/RecipientTable/useMessageCells.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _broadcast = require('shared/enum/broadcast');
var _format = require('web/screens/Broadcast/format');
var _useCampaignSchedule = require('web/screens/Broadcast/useCampaignSchedule');
var _StatusPill = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/StatusPill'); var _StatusPill2 = _interopRequireDefault(_StatusPill);








/* A recipient's Status, Scheduled at and Sent at cells, the same wherever
 * the recipients table shows a saved recipient (review R800-49). A queued
 * message whose time is ahead reads Scheduled (Rev 27 P2); one queued or
 * processing with no time reads Now. One waiting for consent says when it
 * was asked, under its pill, and has no Sent at yet. */
const useMessageCells = (message) => {
  const isScheduled = _useCampaignSchedule.useIsAhead.call(void 0, _optionalChain([message, 'optionalAccess', _ => _.Status]) === _broadcast.broadcastMsgStatus.QUEUED ? _nullishCoalesce(message.ScheduledAt, () => ( null)) : null)
  if (!message) return { status: null, scheduledAt: null, sentAt: null }
  const isWaiting = message.Status === _broadcast.broadcastMsgStatus.AWAITING_CONSENT
  return {
    status: (
      _react2.default.createElement(_StatusPill2.default, {
        status: message.Status,
        desc: message.ErrorCode || null,
        isScheduled: isScheduled,
        askedAt: isWaiting ? message.SentAt || message.ScheduledAt || null : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
      )
    ),
    scheduledAt: message.ScheduledAt
      ? _format.formatSendTime.call(void 0, message.ScheduledAt)
      : ([_broadcast.broadcastMsgStatus.QUEUED, _broadcast.broadcastMsgStatus.PROCESSING].includes(message.Status) ? 'Now' : ''),
    sentAt: message.SentAt && !isWaiting ? _format.formatSendTime.call(void 0, message.SentAt) : null,
  }
}

exports. default = useMessageCells
